import type { ReactNode } from 'react';

import { Button, type ButtonProps } from '~/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { cn } from '~/utils/cn';

/**
 * Icon-only button with the two things every one needs: an accessible name
 * (`aria-label`) and a hover tooltip saying what it does.
 */
export function IconButton({
  label,
  children,
  className,
  ...props
}: Omit<ButtonProps, 'aria-label' | 'children'> & { label: string; children: ReactNode }) {
  return (
    <Tooltip delayDuration={300}>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={label}
          className={cn('h-8 w-8 cursor-pointer', className)}
          {...props}
        >
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
